<template>
  <div v-if="isViewActiveLocal">
    <div class="vx-row limit-width_fixed-scalable" >
      <div class="vx-col" vs-lg="4" style="margin:auto">
        <vx-card class="mt-3 glow-effect_dark limit-width_fixed card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="MenuIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button size="large"
                        class="w-full button-text__left-align glow-effect_primary__hover back-button bg-color"
                        style="border-radius:0 7px 7px 0"
                        type="filled"
                        color=""
                        @click="backToMenu">
              <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
              Back To Menu
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>

    <div class="mt-8">
      <ul style="margin-top: 1rem;flex-wrap: wrap;">
        <div class="limit-width_fixed-scalable" style="text-align: left;">
          <li v-for="(course, index) in modules.map(function(item) {return item.courseName }).filter(function(value, index, self) {return self.indexOf(value) === index})" :key="index" class="mb-4">
            <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 410px;">
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text glow-effect_bg-color__blend bg-color">
                    <span><feather-icon class="pt-1" icon="BookOpenIcon" svg-classes="stroke-current"></feather-icon></span>
                  </div>
                </template>

                <vs-button
                  :disabled="true"
                  size="large"
                  class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-item text__school-tertiary-color bg-color"
                  type="filled"
                  color="">
                  {{ course }}
                </vs-button>
              </vx-input-group>
            </vx-card>

            <ul style="margin-top: 0.2rem;margin-bottom: 1.2rem;flex-wrap: wrap;">
              <li v-for="(mod, modIndex) in modules.filter(function(item){return item.courseName == course})" :key="modIndex" class="mb-3">
                <vx-card card-background="#11193f" class="glow-effect_dark limit-width_fixed-scalable card__no-padding">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text glow-effect_dark" style="background-color: #41475E;border-radius: 5px 0 0 5px !important;">
                        <span><feather-icon class="pt-1" icon="CodesandboxIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button
                      size="large"
                      class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                      style="border-radius:0 7px 7px 0"
                      @click="moduleSelected(mod)">
                      {{ mod.moduleName }}
                    </vs-button>
                  </vx-input-group>
                </vx-card>
              </li>
            </ul>
          </li>
        </div>
      </ul>
    </div>
    
  </div>
</template>

<script>
export default {
  components: {
    
  },
  data() {
    return {
      modules: []
    };
  },
  props: {
    isViewActive: {
      required: false,
    },
    availableModules: {
      type: Array,
      required: true 
    }
  },
  watch: {
    isViewActive: function (val) {
      if(val){
        this.getStudentMentorModules();
      }
    }
  },
  computed: {
    isViewActiveLocal: {
      get() {
        return this.isViewActive;
      }
    }
  },
  methods: {
    getStudentMentorModules() {
      var self = this;
      self.$emit("showLoadingOnElement", "whole_page", 1, "material");
      var onSuccess = function (response) {
        self.modules = response.data.filter(x=> self.availableModules.filter(y => y == x.moduleId).length > 0);
      };
      var onFinally = function () {
        self.$emit("stopLoadingOnElement", "whole_page");
      };

      self.$ajaxGet(self, "MentorModule/GetMentorModuleForStudent", onSuccess, onFinally);
    },
    moduleSelected(mod) {
      this.$emit("moduleSelected", mod);
    },
    backToMenu() {
      this.$emit("backToMenu");
    }
  }
};
</script>